<template>
  <form @submit.prevent="onSave">
    <b-form-group label="Upload PFA File">
      <b-form-file
        v-model="localFile"
        :accept="accept"
        browse-text="Browse"
        @input="onFileChange"
      />
    </b-form-group>
    <div v-if="isPdf" class="rounded p-2">
      <vue-pdf-embed :source="pdfSrc" style="height:500px;width:100%" :height="500" />
    </div>
    <div v-else-if="isExcel" class="table-responsive rounded p-2">
      <table class="table table-sm table-bordered mb-0">
        <tbody>
          <tr v-for="(row, rIdx) in excelPreview" :key="rIdx">
            <td v-for="(cell, cIdx) in row" :key="cIdx">{{ cell }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-muted">No preview available.</div>
    <div class="d-flex justify-content-end mt-3">
      <b-button type="submit" variant="primary" :disabled="saving || !localFile">
        {{ saving ? 'Saving...' : 'Save' }}
      </b-button>
    </div>
  </form>
  </template>
<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
export default {
  name: 'PfaUploader',
  components: {
    VuePdfEmbed
  },
  props: {
    value: { type: Object, default: () => ({ file: null, meta: {} }) },
    projectContractId: { type: [String, Number], default: null },
  },
  data() {
    return { localFile: null, excelPreview: [], pdfSrc: null, saving: false }
  },
  computed: {
    accept() {
      return '.pdf,.xls,.xlsx'
    },
    fileName() {
      return this.localFile?.name || this.value?.fileName || ''
    },
    isPdf() {
      return this.localFile?.type === 'application/pdf'
    },
    isExcel() {
      return (
        this.localFile &&
        (this.localFile.type.includes('sheet') || this.localFile.name.match(/\.xlsx?$|\.xls?$/i))
      )
    },
  },
  methods: {
    async onFileChange(file) {
      this.$emit('input', { ...this.value, file })
      if (!file) return
      if (this.isPdf) {
        this.pdfSrc = URL.createObjectURL(file)
        this.excelPreview = []
      } else if (this.isExcel) {
        // lightweight excel preview: read first sheet CSV via browser APIs if SheetJS exists
        try {
          if (window.XLSX) {
            const buf = await file.arrayBuffer()
            const wb = window.XLSX.read(buf, { type: 'array' })
            const wsname = wb.SheetNames[0]
            const ws = wb.Sheets[wsname]
            const rows = window.XLSX.utils.sheet_to_json(ws, { header: 1 })
            this.excelPreview = rows.slice(0, 30) // cap preview
          } else {
            this.excelPreview = [[
              'Excel preview requires SheetJS (XLSX) loaded in page.'
            ]]
          }
          this.pdfSrc = null
        } catch (e) {
          this.excelPreview = [[`Failed to parse excel: ${e.message}`]]
        }
      }
    },
    async onSave() {
      if (!this.localFile) return
      try {
        this.saving = true
        let res = await this.$store.dispatch('busdev/uploadProjectPfa', {
          project_contract_id: this.projectContractId,
          file: this.localFile,
        })
        if (res?.status !== 'success') {
          res = await this.$store.dispatch('busdevPfa/uploadProjectPfa', {
            project_contract_id: this.projectContractId,
            file: this.localFile,
          }).catch(() => null)
        }
        if (!res || res.status !== 'success') throw res?.data
        const { project_contract_id, url_upload } = res.data || {}
        this.$emit('uploaded', { project_contract_id, url_upload })
        this.$bvToast?.toast('PFA saved', { variant: 'success' })
      } catch (e) {
        this.$bvToast?.toast('Failed to save PFA', { variant: 'danger' })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
